// extracted by mini-css-extract-plugin
export default {"zoomModal":"E4-z","image":"F4-z","button":"G4-z","isOverlayShown":"H4-z"};